import { render, staticRenderFns } from "./jpDetailDialog.vue?vue&type=template&id=12bb73a3&scoped=true"
import script from "./jpDetailDialog.vue?vue&type=script&lang=js"
export * from "./jpDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./jpDetailDialog.vue?vue&type=style&index=0&id=12bb73a3&prod&lang=scss"
import style1 from "./jpDetailDialog.vue?vue&type=style&index=1&id=12bb73a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bb73a3",
  null
  
)

export default component.exports